export const environment = {
  firebase: {
    // Prod firebase
    apiKey: "AIzaSyA_sO7zpXblRXZMQdSJqbUy1SyhnYPeWaM",
    authDomain: "gcp-sqo-iflex-thailand-p.firebaseapp.com",
    projectId: "gcp-sqo-iflex-thailand-p",
    storageBucket: "gcp-sqo-iflex-thailand-p.appspot.com",
    messagingSenderId: "619452817461",
    apiURL: "https://iflex-thailand-api.syensqo.com/api/",
    nonApiURL: "https://iflex-thailand-api.syensqo.com/"
  },
  production: true
};
